

<div class="TootTiptopSection">  
    <button  class=" data-protection-close dialog-close-btn" mat-icon-button aria-label="close dialog" mat-dialog-close>
       <img src="/icons/close-kb.svg" alt=""  class="close"width="20" height="20" />
      </button>
</div>

<mat-dialog-content class="data-protection-dialog">
    <div class="content ">
        <div class="container-fluid kb-annoucement" style="padding-top:10px;">
            <div class="description" [innerHTML]="privacyNotice"></div>          
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="mat-primary  mat-accept" (click)="accept()" mat-button>{{ 'common.text_button_accept' | cxTranslate }}</button>
</mat-dialog-actions>
